/**
 * Captures native window.getComputedStyle before Chart.js can override it.
 *
 * When esbuild bundles with --format=esm but the output is loaded as a
 * classic <script> (no type="module"), Chart.js's top-level
 * `var getComputedStyle` leaks into the global scope and replaces the
 * native browser function with a wrapper that calls itself — causing
 * infinite recursion (RangeError: Maximum call stack size exceeded).
 *
 * This module MUST be imported before "chart.js" so esbuild places its
 * __esm initialiser ahead of Chart.js's in the bundle.
 */
export const nativeGetComputedStyle = window.getComputedStyle
